<template>
  <section class="pd-y-10">
    <!-- style="max-width: 600px !important" -->
    <div class="container" style="padding-bottom: 0px; padding-top: 20px;">
      <div class="section-title" style="text-align:left;">
        <h2>{{ comp.task }}</h2>
        <!-- <p class="mg-b-0">{{comp.f1}}</p> -->
      </div>
    </div>
    <div class="container mg-b-10" style="padding-top: 0px;">
      <div class="row">
        <!-- <div role="button" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <div class="card bg-dark ht-150 overflow-hidden" style="border-radius: 10px; background-color: #13407a !important;">
            <a @click="mdlSurvey= true" href="javascript:void(0)" class="">
              <div class="card-img-overlay d-flex align-items-center text-center">
                <div class="wd-100p">
                  <h4 class="text-white lh-1 text-truncate-2">Сургалтын хэрэгцээг тодорхойлох судалгаа</h4>
                  <p class="card-text text-white">[ Дэлгэрэнгүй ]</p>
                </div>
              </div>
            </a>
          </div>
        </div> -->

        <div
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
          v-for="(c, i) in types.filter(x=>x.courseCount>0)"
          :key="i"
          role="button"
        >
          <div class="card bg-dark ht-150 overflow-hidden" style="border-radius: 10px;">
            <router-link
              v-if="$store.state.app.pages.filter(x => x.st1 == 'courses').length"
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: {
                  id: $store.state.app.pages.filter(x => x.st1 == 'courses')[0]
                    .id,
                  cid: c.id
                }
              }"
            >
              <img
                v-if="c.field1 != null && c.field1 != ''"
                class="card-img-top op-2"
                :src="`${c.field1}?w=400&h=250&mode=crop`"
              />
              <img
                v-else
                class="card-img-top op-1"
                src="assets/img/course-type.jpg"
              />
              <div
                class="card-img-overlay d-flex align-items-center text-center"
              >
                <div class="wd-100p">
                  <h4 class="text-white lh-1 text-truncate-2">{{ c.s1 }}</h4>
                  <p class="card-text text-white">
                    Нийт {{ c.courseCount }} хичээл
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="mdlSurvey" fullscreen size="xl" title="" scrollable hide-footer>
      <iframe src='https://flo.uri.sh/visualisation/21975537/embed' title='Interactive or visual content' class='flourish-embed-iframe' frameborder='0' scrolling='no' style='width:100%;height:600px;' sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'></iframe><div style='width:100%!;margin-top:4px!important;text-align:right!important;'><a class='flourish-credit' href='https://public.flourish.studio/visualisation/21975537/?utm_source=embed&utm_campaign=visualisation/21975537' target='_top' style='text-decoration:none!important'><img alt='Made with Flourish' src='https://public.flourish.studio/resources/made_with_flourish.svg' style='width:105px!important;height:16px!important;border:none!important;margin:0!important;'> </a></div>
      <!-- <img src="https://res.gosmart.mn/media/bg/bg-survey.jpg" style="width: 100%; height: calc(100vh - 150px)" /> -->
    </b-modal>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      mdlSurvey: false,
      types: []
    };
  },
  mounted() {
    this.loadTypes();
  },
  methods: {
    loadTypes() {
      request({
        api: { method: "GET", url: "type/getData" },
        params: {
          key: "courseType"
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.types = res.data.types;
          if (res.data.types.length > 12) {
            this.types = res.data.types.filter(x => x.courseCount > 0);
          }
          // console.log('type/getData=> ', res);
        }
      });
    }
  }
};
</script>

<style>
.text-truncate-2 {
  font-weight: 500;
  overflow:hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 55px;
  max-height: 55px;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>
